enum DEPLOYMENT_STAGE {
    LOCAL = "local",
    TEST = "test",
    PRODUCTION = "production"
}

export const LOCAL_ENVIRONMENT = process.env.REACT_APP_STAGE === DEPLOYMENT_STAGE.LOCAL;
export const TEST_ENVIRONMENT = process.env.REACT_APP_STAGE === DEPLOYMENT_STAGE.TEST;
export const LOCAL_OR_TEST_ENVIRONMENT = LOCAL_ENVIRONMENT || TEST_ENVIRONMENT;
export const PRODUCTION_ENVIRONMENT = process.env.REACT_APP_STAGE === DEPLOYMENT_STAGE.PRODUCTION;